<div class="layout-content">
	<form (ngSubmit)="submit()" [formGroup]="editDeviceForm" *ngIf="editDeviceForm">
		<div class="grid">
			<div class="col-12" *ngFor="let aux of auxList" [ngClass]="customPaddingX()">
				<div class="flex justify-content-between flex-wrap border-bottom-1 border-100"
					[ngClass]="dynamicInputTextFormat('borderRow')">
					<div class="flex align-items-center justify-content-center"
						[ngClass]="dynamicInputTextFormat('label')">{{ aux.label | translate }}</div>
						<div class="flex align-items-center justify-content-center"
							[ngClass]="dynamicInputTextFormat('borderInput')">
							<p-inputSwitch [formControlName]="aux.value" (onChange)="save(aux.value)"></p-inputSwitch>
						</div>
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f[aux.value])" class="flex align-items-center text-50 pt-1"
					[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
			</div>
		</div>

		<div class="grid mt-5 mb-1 mx-1 flex justify-content-center align-items-center">
			<button type="button" pButton pRipple (click)="closeDialog()" label="{{ 'CLOSE' | translate }}"
				class="p-button-secondary text-xl font-normal mt-2 mx-1" [ngClass]="dynamicButtonWidth()">
			</button>
		</div>
	</form>
</div>